import { FloorContainer } from '../../containers/advancedFilters/FloorContainer';
import { IFilter } from '../../types/advancedFilters';

export const floor: IFilter = {
  component: FloorContainer,
};
